"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _useWindowSize2 = _interopRequireDefault(require("react-use/lib/useWindowSize"));
var _filter2 = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/filter.svg"));
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _FilterSortItem = _interopRequireDefault(require("./FilterSortItem"));
var _FilterSortSearch = _interopRequireDefault(require("./FilterSortSearch"));
var _ModalView = _interopRequireDefault(require("../../View/ModalView/ModalView"));
var _MultiSelectInput = require("../../Input/MultiSelectInput/MultiSelectInput");
var _breakpoints = require("../../style/breakpoints");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import { type ThemeType } from '../../style/ThemeTypes';*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    root: {
      marginBottom: '1.25rem'
    },
    filter: (0, _defineProperty2.default)({
      display: 'none'
    }, theme.breakpoints.gte.tablet.portrait, {
      display: 'flex',
      alignItems: 'flex-end'
    }),
    trigger: (0, _defineProperty2.default)({
      display: 'block',
      width: '100%'
    }, theme.breakpoints.gte.tablet.portrait, {
      display: 'none'
    }),
    triggerButton: (0, _defineProperty2.default)((0, _defineProperty2.default)({
      marginBottom: 0
    }, "& .".concat(_MultiSelectInput.SELECT_DISPLAY_NAME, "__placeholder"), _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      color: theme.colors.black
    })), "& .".concat(_MultiSelectInput.SELECT_DISPLAY_NAME, "__control"), {
      paddingLeft: '1.75rem',
      borderColor: theme.colors.blueGrey,
      backgroundColor: theme.colors.blueGrey,
      backgroundImage: "url(".concat(_filter2.default, ")"),
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '.5rem 50%',
      backgroundSize: '1rem',
      '&:hover, &:focus, &:focus-within': {
        borderColor: theme.colors.blueGrey,
        backgroundColor: theme.colors.blueGrey
      }
    }),
    modalButtons: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '1rem'
    },
    modalButton: _objectSpread(_objectSpread({}, theme.typography.header5), {}, {
      margin: '0 .75rem'
    })
  };
});
/*:: type Props = {
  children?: React.Node,
  className?: string,
  defaultValue?: string,
  isOpen?: boolean,
  mode?: React.Node,
  onChange?: (event: SyntheticEvent<HTMLInputElement>) => any,
  onReset?: () => mixed,
  searchKey?: string,
  sidebarOpener?: React.Node,
  width?: number
};*/
var FilterSort = function FilterSort(_ref /*:: */) {
  var children = _ref /*:: */.children,
    className = _ref /*:: */.className,
    defaultValue = _ref /*:: */.defaultValue,
    isOpen = _ref /*:: */.isOpen,
    mode = _ref /*:: */.mode,
    onChange = _ref /*:: */.onChange,
    onReset = _ref /*:: */.onReset,
    searchKey = _ref /*:: */.searchKey,
    sidebarOpener = _ref /*:: */.sidebarOpener,
    width = _ref /*:: */.width;
  var intl = (0, _reactIntl.useIntl)();
  var classes = useStyles();
  var _useWindowSize = (0, _useWindowSize2.default)(),
    windowWidth = _useWindowSize.width;
  var search = /*#__PURE__*/React.createElement(_FilterSortSearch.default, {
    defaultValue: defaultValue,
    searchKey: searchKey,
    onChange: onChange
  });
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(classes.root, className),
    "data-testid": "filter-sort"
  }, (typeof width === 'number' ? width : windowWidth) < _breakpoints.devices.tablet.portrait ? /*#__PURE__*/React.createElement(_ModalView.default, {
    isOpen: isOpen,
    trigger: function trigger(_ref2) {
      var show = _ref2.show;
      return /*#__PURE__*/React.createElement("button", {
        className: classes.trigger,
        onClick: show
      }, /*#__PURE__*/React.createElement(_FilterSortItem.default, {
        className: classes.triggerButton,
        onClick: show,
        disabled: true,
        placeholder: intl.formatMessage({
          id: 'filterSort.trigger',
          defaultMessage: 'Edit filters'
        })
      }));
    }
  }, function (_ref3) {
    var hide = _ref3.hide;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.modalButtons
    }, /*#__PURE__*/React.createElement("button", {
      className: classes.modalButton,
      onClick: hide
    }, /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Done",
      id: "filterSort.done"
    })), /*#__PURE__*/React.createElement("button", {
      className: classes.modalButton,
      onClick: onReset
    }, /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Clear filters",
      id: "filterSort.reset"
    }))), search, children, mode, sidebarOpener);
  }) : /*#__PURE__*/React.createElement("div", {
    className: classes.filter
  }, children, search, mode, sidebarOpener));
};
FilterSort.displayName = 'FilterSort';
var _default = exports.default = FilterSort;
//# sourceMappingURL=FilterSort.js.map